var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "filter-search-form note note-info note-bordered margin-bottom-20",
    },
    [
      _c("div", { staticClass: "row margin-bottom-20" }, [
        _c("div", { staticClass: "col-md-9" }, [
          _c("div", { staticClass: "col-md-7" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("label", { staticClass: "filtro-label-avancado" }, [
                  _vm._v("Tipos"),
                ]),
                _vm._v(" "),
                _c("wes-Lookup", {
                  ref: "lookupPerfil",
                  attrs: {
                    entityName: "FN_GERENCIAISPERFIS",
                    resultFields: "NOME",
                    whereClauseSessionKey:
                      "lookupPerfilFluxoCaixaGerencialWhere",
                    placeholders: _vm.getPlaceHoldersPerfil(),
                    enabled: _vm.isTreeViewLoaded(),
                  },
                  on: {
                    change: _vm.selecionarPerfil,
                    mounted: _vm.limparPerfilSelecionado,
                    clear: _vm.limparPerfilSelecionado,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filtro-gerenciais-right-actions col-md-5",
              on: { click: _vm.actionsClick },
            },
            [
              _c("label", { staticClass: "filtro-label-avancado" }, [
                _vm._v("Período"),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.isDateError
                  ? _c("span", { staticClass: "badge badge-danger" }, [
                      _vm._v(" Data inicial deve ser menor que data final "),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("fluxo-caixa-date-range-input", {
                attrs: {
                  gerarEnabled: _vm.isTreeViewLoaded(),
                  startView: 0,
                  buttonDescription: "Gerar",
                  startDate: _vm.getStartDateValue(),
                  endDate: _vm.getEndDateValue(),
                },
                on: {
                  "error-input": _vm.onErrorDateRange,
                  apply: _vm.applyFilter,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row collapse",
          attrs: { id: "filtro-body", "aria-expanded": "false" },
        },
        [
          _c(
            "div",
            { staticClass: "col-md-3", staticStyle: { "min-height": "300px" } },
            [
              _c(
                "ul",
                { staticClass: "nav nav-tabs tabs-left tabbable-line" },
                [
                  _c("li", { staticClass: "active" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#treeview_empresaFilial",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-building" }),
                        _vm._v(" Empresas "),
                        _vm.getTotalSelectedEmpresaFilial() > 0 &&
                        !_vm.isEmpresaTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getTotalSelectedEmpresaFilial()) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isEmpresaTreeViewLoading()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isEmpresaMissing
                            ? _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_vm._v(" selecione ")]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "pulsate-regular" }, [
                    _c(
                      "a",
                      {
                        class: {
                          "not-active":
                            _vm.isContaTreeViewLoading() ||
                            !_vm.isContaEmpresaMestreRegra(),
                        },
                        attrs: {
                          href: "#treeview_contas",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-bank" }),
                        _vm._v(" Contas "),
                        _vm.getTotalSelectedContas() > 0 &&
                        !_vm.isContaTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(
                                " " + _vm._s(_vm.getTotalSelectedContas()) + " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isContaTreeViewLoading()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: { "not-active": _vm.notActiveCCRules() },
                        attrs: { href: "#treeview_cc", "data-toggle": "tab" },
                      },
                      [
                        _c("i", { staticClass: "fa fa-money" }),
                        _vm._v(" CC "),
                        _vm.getTotalSelectedCC() > 0 &&
                        !_vm.isCCTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(
                                " " + _vm._s(_vm.getTotalSelectedCC()) + " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isCCTreeViewLoading()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: {
                          "not-active":
                            _vm.isProjetoTreeViewLoading() ||
                            !_vm.isProjetoEmpresaMestreRegra(),
                        },
                        attrs: {
                          href: "#treeview_projetos",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-line-chart" }),
                        _vm._v(" Projetos "),
                        _vm.getTotalSelectedProjetos() > 0 &&
                        !_vm.isProjetoTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getTotalSelectedProjetos()) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isProjetoTreeViewLoading()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#treeview_avancado",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-gears" }),
                        _vm._v(
                          " Tipos Gerenciais\n                            "
                        ),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isAbrangenciaMissing
                            ? _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_vm._v(" selecione ")]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#treeview_filtro",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-gear" }),
                        _vm._v(
                          " Filtro avançado\n                            "
                        ),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isAbrangenciaMissing
                            ? _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_vm._v(" selecione ")]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9" }, [
            _c("div", { staticClass: "tab-content" }, [
              _c(
                "div",
                {
                  staticClass: "tab-pane active",
                  attrs: { id: "treeview_empresaFilial" },
                },
                [
                  _c("wes-treeview", {
                    key: _vm.chaveUnicaPerfilSelecionado + "-1",
                    attrs: {
                      store: _vm.getTreeViewEmpresaFilial(),
                      "treeview-id": "empresaFilial",
                      endpoint: "empresasFiliaisPermitidasUsuario",
                      marcar: "false",
                    },
                    on: {
                      "item-selected": function ($event) {
                        return _vm.itemSelected(
                          $event,
                          _vm.tabInfo.empresaFilial
                        )
                      },
                      loaded: _vm.setTotalTreeViews,
                      unloaded: _vm.setUnloadedTreeView,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  attrs: { id: "treeview_contas" },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("wes-treeview-select", {
                          key: _vm.chaveUnicaPerfilSelecionado + "-2",
                          ref: "treeviewSelectContas",
                          attrs: {
                            markAllByDefault: true,
                            store: _vm.getTreeViewContas(),
                            "treeview-id": "contas",
                            definitions: _vm.contaDefinitions,
                          },
                          on: {
                            "menu-item-selected": _vm.menuItemSelected,
                            "lookup-item-selected": _vm.lookupItemSelected,
                            "item-selected": function ($event) {
                              return _vm.itemSelected(
                                $event,
                                _vm.tabInfo.contas
                              )
                            },
                            "tree-view-loaded": _vm.setTotalTreeViews,
                            "tree-view-unloaded": _vm.setUnloadedTreeView,
                            "lookup-empty": _vm.onLookupContasVazio,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-pane fade", attrs: { id: "treeview_cc" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        key: _vm.chaveUnicaPerfilSelecionado + "-5",
                        staticClass: "row",
                      },
                      [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            [
                              _c("label", { staticClass: "label-title" }, [
                                _vm._v(
                                  "Exibir lançamentos sem Centros de Custos informados (NI)"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("wes-switch", {
                                attrs: {
                                  value:
                                    _vm.getExibirLancamentosSemCCInformado(),
                                },
                                on: {
                                  change:
                                    _vm.exibirLancamentosSemCcInformadoChanged,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-top": "10px" },
                      },
                      [
                        _c("wes-treeview-select", {
                          key: _vm.chaveUnicaPerfilSelecionado + "-3",
                          ref: "treeviewSelectCC",
                          attrs: {
                            store: _vm.getTreeViewCentroDeCustos(),
                            "treeview-id": "CC",
                            definitions: _vm.ccDefinitions,
                          },
                          on: {
                            "menu-item-selected": _vm.menuItemSelected,
                            "lookup-item-selected": _vm.lookupItemSelected,
                            "item-selected": function ($event) {
                              return _vm.itemSelected(
                                $event,
                                _vm.tabInfo.centroDeCustos
                              )
                            },
                            "tree-view-loaded": _vm.setTotalTreeViews,
                            "tree-view-unloaded": _vm.setUnloadedTreeView,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  attrs: { id: "treeview_projetos" },
                },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        key: _vm.chaveUnicaPerfilSelecionado + "-7",
                        staticClass: "row",
                      },
                      [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            [
                              _c("label", { staticClass: "label-title" }, [
                                _vm._v(
                                  "Exibir lançamentos sem Projetos informados (NI)"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("wes-switch", {
                                attrs: {
                                  value:
                                    _vm.getExibirLancamentosSemProjetoInformado(),
                                },
                                on: {
                                  change:
                                    _vm.exibirLancamentosSemProjetoInformadoChanged,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  staticStyle: { "padding-top": "10px" },
                  attrs: { id: "treeview_avancado" },
                },
                [
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "btn",
                        class: _vm.colorSelected,
                        attrs: { href: "javascript:;" },
                      },
                      [
                        _c("i", { staticClass: "fa fa-bar-chart" }),
                        _vm._v(
                          " Previsto x Realizado\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("transition-group", { attrs: { name: "slide-fade" } }, [
                    _vm.isAbrangenciaEnabled()
                      ? _c(
                          "div",
                          { key: "abrangenciaFilter" },
                          [
                            _c("fluxo-caixa-gerencial-filtro-abrangencia", {
                              attrs: {
                                isFilterNotSelected: _vm.isAbrangenciaMissing,
                                colorSelected: _vm.colorSelected,
                                colorDeselected: _vm.colorDeselected,
                              },
                              on: {
                                "filtro-selected": _vm.abrangenciaSelected,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isCategoriaEnabled() &&
                    !_vm.isPrevistoRealizadoEnabled()
                      ? _c(
                          "div",
                          { key: "categoriaFilter", staticClass: "row" },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-12" },
                              [
                                _c(
                                  "fluxo-caixa-gerencial-filtro-categoria-titulo",
                                  {
                                    attrs: {
                                      colorSelected: _vm.colorSelected,
                                      colorDeselected: _vm.colorDeselected,
                                    },
                                  }
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTituloEnabled()
                      ? _c("div", { key: "tituloFilter", staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-12", attrs: { vi: "" } },
                            [
                              _c("fluxo-caixa-gerencial-filtro-titulo", {
                                attrs: {
                                  colorSelected: _vm.colorSelected,
                                  colorDeselected: _vm.colorDeselected,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c("div", { key: "comandosPerfil" }, [
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Nome do perfil")]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control",
                              attrs: { type: "text", id: "nomePerfil" },
                              domProps: { value: _vm.nomePerfil },
                              on: { input: _vm.setNomePerfil },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v(" ")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-actions" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-info",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.persistirPerfil()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-save" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isPerfilSistema()
                                          ? "Salvar cópia de perfil pré-definido"
                                          : "Salvar perfil"
                                      ) +
                                      "\n                                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.perfilSelecionado() && !_vm.isPerfilSistema()
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-danger",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.excluirPerfil()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-times" }),
                                      _vm._v(
                                        " Excluir perfil\n                                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  attrs: { id: "treeview_filtro" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-9" },
                    [
                      _c("fluxo-caixa-gerencial-filtro-abrangencia-avancado", {
                        attrs: {
                          colorSelected: _vm.colorSelected,
                          colorDeselected: _vm.colorDeselected,
                        },
                      }),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm._l(_vm.lookupItems, function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c(
                              "label",
                              { staticClass: "filtro-label-avancado" },
                              [_vm._v(_vm._s(item.label))]
                            ),
                            _vm._v(" "),
                            _c("wes-lookup-multiple", {
                              ref: item.ref,
                              refInFor: true,
                              attrs: {
                                entityName: item.entityName,
                                resultFields: item.resultFields,
                                placeholders: _vm.getPlaceHoldersCustom(
                                  item.placeholder
                                ),
                                enabled: _vm.isTreeViewLoaded(),
                              },
                              on: {
                                change: item.changeMethod,
                                clear: item.clearMethod,
                                mounted: function ($event) {
                                  return _vm.lookupAvancadoMontado(item)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("hr"),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-md-3 filtro-gerenciais-actions collapsible",
        attrs: {
          "data-toggle": "collapse",
          "data-parent": "false",
          "data-target": "#filtro-body",
        },
      },
      [
        _c("div", { staticStyle: { "padding-top": "20px" } }, [
          _c(
            "p",
            { staticStyle: { "font-size": "14px", "text-align": "right" } },
            [
              _vm._v("Filtro avançado "),
              _c("i", {
                staticClass: "fa fa-chevron-down font-black",
                staticStyle: { cursor: "pointer" },
                attrs: { title: "Clique para expandir o menu de filtros." },
              }),
            ]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12", staticStyle: { "padding-top": "10px" } },
        [
          _c("div", { attrs: { id: "treeview_projetos_custom" } }, [
            _c("div", { attrs: { id: "treeview_projetos_custom_filtro" } }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }